<template>
  <section class="clients">
    <div class="container">
      <div class="section-title">
        <p class="subtitle">{{ $t('clients.subtitle') }}</p>
        <h2>{{ $t('clients.title') }}</h2>
        <p class="description">{{ $t('clients.description') }}</p>
      </div>
      <div class="clients-grid">
        <div class="client-logo" v-for="client in clients" :key="client.name">
          <img :src="client.logo" :alt="client.alt" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import wehorse from '@/assets/clients/wehorse.png'
import rtlPlus from '@/assets/clients/rtl-plus.png'
import spin from '@/assets/clients/spin.png'
import boldmetrics from '@/assets/clients/boldmetrics.webp'
import mediaMarkt from '@/assets/clients/media-markt.png'
import janusAi from '@/assets/clients/janus-ai.png'
import ipsos from '@/assets/clients/Logo_Ipsos.svg.png'

const clients = [
  { name: 'wehorse', logo: wehorse, alt: 'wehorse client logo — equestrian streaming platform powered by Data Do data solutions' },
  { name: 'RTL+', logo: rtlPlus, alt: 'RTL+ client logo — major European streaming service using Data Do data engineering' },
  { name: 'Spin', logo: spin, alt: 'Spin client logo — mobility company leveraging Data Do AI automation' },
  { name: 'Bold Metrics', logo: boldmetrics, alt: 'Bold Metrics client logo — AI-powered body measurement platform' },
  { name: 'Media Markt', logo: mediaMarkt, alt: 'Media Markt client logo — European electronics retailer using Data Do enterprise solutions' },
  { name: 'Janus AI', logo: janusAi, alt: 'Janus AI client logo — AI company partnering with Data Do for data infrastructure' },
  { name: 'Ipsos', logo: ipsos, alt: 'Ipsos client logo — global market research company partnering with Data Do' }
]
</script>

<style scoped>
.clients {
  padding: 80px 20px;
  background-color: var(--gray-light);
}

.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.subtitle {
  color: var(--primary-color);
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: var(--text-color);
}

.description {
  max-width: 600px;
  margin: 0 auto;
  opacity: 0.8;
}

.clients-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 50px;
  opacity: 0.7;
}

.client-logo {
  flex: 1 1 200px;
  max-width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.client-logo img {
  max-width: 100%;
  max-height: 60px;
  filter: grayscale(100%);
  transition: filter 0.3s ease;
}

.client-logo:hover img {
  filter: grayscale(0%);
}

@media (max-width: 768px) {
  .clients-grid {
    gap: 30px;
  }
  .client-logo {
    flex: 1 1 150px;
  }
}
</style>
